/**
 * Mix this into the events of views where we don't want mouse events captured by the 'drag' plugin to be applied.
 * ( The 'drag' / 'grabby hand' feature that overlays the page views in Document and Page Mode. )
 * Most notably this allow the selection of text in these views.
 * Examples: unrenderable pages, error pages, cold/text overlays
 */


module.exports = {

    'mousedown': function(e) {
        e.stopPropagation();
    },

    'mouseup': function(e) {
        e.stopPropagation();
    },

    mousemove: function(e) {
        e.stopPropagation();
    }

};


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/page/preventDragEventsMixin.js
 ** module id = 438
 ** module chunks = 0
 **/